// Maps the raw survey API error codes (the api client surfaces `json.error` as
// the thrown message) to plain, human copy for the builder's inline banners.
const COPY: Record<string, string> = {
  survey_publish_limit_reached:
    "You've reached your published-survey limit. Upgrade your plan or add the Survey add-on to publish more.",
  survey_locked:
    'This survey has responses, so its structure is locked. Duplicate it to make bigger changes.',
  not_publishable: 'Add at least one question that collects an answer before publishing.',
  slug_taken: 'That web address is already taken — pick another.',
  survey_not_deletable: 'Only draft surveys with no responses can be deleted.',
  survey_not_published: 'Publish the survey before creating invites.',
  survey_invite_limit_reached: 'This survey has reached its invite limit.',
  email_invites_require_business: 'Email invites are part of the Business plan.',
  email_not_configured: 'Email sending is not set up yet. You can still copy invite links.',
  survey_misconfigured: 'Something is off with this survey. Try reloading.',
  not_found: "We couldn't find that survey.",
  invalid_input: 'Please check the highlighted fields and try again.',
  create_failed: 'Something went wrong creating the survey. Please try again.',
  update_failed: 'Something went wrong saving. Please try again.',
  rate_limited: "You're going a bit fast. Please wait a moment and try again.",
  // AI drafting (Phase 5b) — mirrors the page builder's AI error copy.
  ai_not_configured: 'AI drafting is not available right now. Please try again later.',
  ai_not_in_plan: 'AI drafting is included on every paid plan. Upgrade to use it.',
  quota_exceeded:
    "You've used all your AI generations for this month. You can buy 100 more for $9 on the Billing page.",
  invalid_generation: "The AI draft didn't come out usable. Tweak your description and try again.",
  ai_call_failed: 'The AI service had a hiccup. Please try again.',
  persistence_failed: 'The draft was generated but could not be saved. Please try again.',
  preview_failed: 'Could not open the preview. Please try again.',
  survey_published: 'This survey is live — open its public link instead.',
};

export function surveyErrorCopy(message: string): string {
  return COPY[message] ?? message;
}
